import { isTransitionalPeriodActive } from 'shared/ncts/common/constants'

const E1114Validator = {
  getMaximumLengthOfLoadingLocation: (): number => (isTransitionalPeriodActive() ? 17 : 35),
} as const

export default E1114Validator
